import React from "react"
import { Box, Typography } from "@mui/material"
import SegmentedPill from "@/components/ui/SegmentedPill"
import { KPI_LABEL_SX } from "@/components/ui/KpiTile"
import { DIVIDER, INK } from "@/features/route/alertCardParts.jsx"

const LEG_OPTIONS = [
  { value: "greatcircle", label: "Great circle", tooltip: "Shortest distance" },
  { value: "rhumbline", label: "Rhumb line", tooltip: "Constant course" },
]

/**
 * Leg type of the leg that starts at a manual-route waypoint, shown in its
 * info card.
 */
export default function WaypointEditSection({
  nextLabel,
  legtype = "greatcircle",
  onLegtypeChange = null,
  disabled = false,
}) {
  if (!onLegtypeChange) return null
  return (
    <Box sx={{ pb: "10px", borderBottom: `1px solid ${DIVIDER}` }}>
      <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", mb: "6px" }}>
        <Typography sx={KPI_LABEL_SX}>Leg</Typography>
        {nextLabel && (
          <Typography sx={{ fontSize: 11, fontWeight: 600, color: INK }}>→ {nextLabel}</Typography>
        )}
      </Box>
      <Box sx={disabled ? { opacity: 0.45, pointerEvents: "none" } : null}>
        <SegmentedPill
          fullWidth
          options={LEG_OPTIONS}
          value={legtype}
          onChange={(next) => {
            if (next !== legtype) onLegtypeChange(next)
          }}
        />
      </Box>
    </Box>
  )
}
